import { createRouter, createWebHistory } from "vue-router";
import { routeAvailable } from "../util/integrations";

// import store from '@/store';

const routes = [
	{
		path: "/",
		component: () => import(/* webpackChunkName: "main" */ "../views/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/Dashboard"),
			},
			{
				path: "/:catchAll(.*)",
				component: () => import(/* webpackChunkName: "404" */ "../views/404"),
			},
		],
	},
	{
		path: "/bedrijfspaginas",
		component: () => import(/* webpackChunkName: "main" */ "../views/companypages/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/companypages/Overview"),
			},
			{
				path: "archief",
				component: () => import(/* webpackChunkName: "main" */ "../views/companypages/Archive"),
			},
		],
	},
	{
		path: "/checkbestand",
		meta: { requires: ["flexwell", "zoho"] },
		component: () => import(/* webpackChunkName: "main" */ "../views/checkfile/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/checkfile/Overview"),
			},
		],
	},
	{
		path: "/bedrijfspaginas",
		component: () => import(/* webpackChunkName: "main" */ "../views/companypages/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/companypages/Overview"),
			},
			{
				path: "/:id",
				component: () => import(/* webpackChunkName: "main" */ "../views/companypages/Overview"),
			},
			{
				path: "archief",
				component: () => import(/* webpackChunkName: "main" */ "../views/companypages/Archive"),
			},
		],
	},

	{
		path: "/bedrijfspaginas/:id",
		component: () => import(/* webpackChunkName: "main" */ "../views/companypages/page/__template"),
		children: [
			{
				path: "werknemers",
				component: () => import(/* webpackChunkName: "main" */ "../views/companypages/page/EmployeeList"),
			},
			{
				path: "werknemers/:wid",
				component: () => import(/* webpackChunkName: "main" */ "../views/companypages/page/Employee"),
			},

			{
				path: "activiteiten",
				component: () => import(/* webpackChunkName: "main" */ "../views/companypages/page/ActivityList"),
			},
		],
	},

	{
		path: "/activiteiten",
		component: () => import(/* webpackChunkName: "main" */ "../views/activities/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/activities/Overview"),
			},
			{
				path: "archief",
				component: () => import(/* webpackChunkName: "main" */ "../views/activities/Archive"),
			},
		],
	},

	{
		path: "/activiteiten-herplannen",
		meta: { requires: ["flexwell"] },
		component: () => import(/* webpackChunkName: "main" */ "../views/replan/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/replan/Overview"),
			},
		],
	},

	{
		path: "/activiteiten/:id/",
		component: () => import(/* webpackChunkName: "activities" */ "../views/activities/Companyoverview"),
	},
	{
		path: "/bedrijfspaginas/bewerken/:id",
		component: () => import(/* webpackChunkName: "main" */ "../views/companypages/Edit"),
	},

	{
		path: "/activiteiten/company/:id",
		component: () => import(/* webpackChunkName: "activities" */ "../views/activities/Companyoverview"),
	},

	// {
	// 	path: '/activiteiten/aanmaken',
	// 	component: () =>
	// 		import( /* webpackChunkName: "main" */ '../views/activities/Create'),

	// },
	{
		path: "/reviews",
		component: () => import(/* webpackChunkName: "main" */ "../views/reviews/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/reviews/Overview"),
			},
		],
	},

	{
		path: "/accountgegevens",
		component: () => import(/* webpackChunkName: "main" */ "../views/account/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/account/Overview"),
			},
		],
	},
	{
		path: "/instellingen",
		component: () => import(/* webpackChunkName: "main" */ "../views/settings/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/settings/Overview"),
			},
		],
	},

	{
		path: "/inloggen",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/auth/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/auth/Login"),
			},
		],
	},

	// De oude freelancerlink (ADR-0063). Tijdelijke brug (ADR-0089): stuurt door
	// naar de Specialistlink van de vestiging, of laat er een kiezen.
	{
		path: "/link/:id",
		component: () => import(/* webpackChunkName: "link" */ "../views/freelancers/__template"),
	},

	{
		path: "/activiteiten/:id/",
		component: () => import(/* webpackChunkName: "activities" */ "../views/activities/Companyoverview"),
	},
	{
		path: "/activiteiten/:id/bewerken",
		component: () => import(/* webpackChunkName: "activities" */ "../views/activities/Edit"),
	},
	{
		path: "/activiteiten/:id/archief",
		component: () => import(/* webpackChunkName: "activities" */ "../views/activities/Companyarchive"),
	},

	{
		path: "/activiteiten/company/:id",
		component: () => import(/* webpackChunkName: "activities" */ "../views/activities/Companyoverview"),
	},

	// {
	// 	path: "/activiteiten/aanmaken",
	// 	component: () => import(/* webpackChunkName: "main" */ "../views/activities/Create"),
	// },
	{
		path: "/reviews",
		component: () => import(/* webpackChunkName: "main" */ "../views/reviews/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/reviews/Overview"),
			},
		],
	},

	{
		path: "/accountgegevens",
		component: () => import(/* webpackChunkName: "main" */ "../views/account/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/account/Overview"),
			},
		],
	},
	{
		path: "/instellingen",
		component: () => import(/* webpackChunkName: "main" */ "../views/settings/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/settings/Overview"),
			},
		],
	},
	{
		path: "/specialisten",
		component: () => import(/* webpackChunkName: "main" */ "../views/specialists/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/specialists/Overview"),
			},
		],
	},
	{
		path: "/inloggen",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/auth/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/auth/Login"),
			},
		],
	},

	{
		path: "/wachtwoord-vergeten",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/auth/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/auth/Resetpassword"),
			},
		],
	},

	{
		path: "/wachtwoord-wijzigen",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/auth/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/auth/Newpassword"),
			},
		],
	},

	{
		path: "/registratie-voltooien",
		component: () => import(/* webpackChunkName: "register confirm" */ "../views/auth/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/auth/Registerconfirm"),
			},
		],
	},

	{
		path: "/form-builder",
		meta: { requires: ["flexwell"] },
		component: () => import(/* webpackChunkName: "form-builder" */ "../views/form-builder/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/form-builder/Overview"),
			},
			{
				path: "presets",
				component: () => import("../views/form-builder/Presets"),
			},
			{
				path: "presets/:presetId/edit",
				component: () => import("../views/form-builder/PresetEdit"),
			},
			{
				path: ":id",
				component: () => import("../views/form-builder/Questions"),
			},
			{
				path: ":id/edit/:questionId",
				component: () => import("../views/form-builder/Edit"),
			},
		],
	},

	{
		path: "/intake-formulieren",
		meta: { requires: ["flexwell", "zoho"] },
		component: () => import(/* webpackChunkName: "intake-formulieren" */ "../views/intake-formulieren/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/intake-formulieren/Overview"),
			},
			{
				path: ":id",
				component: () => import("../views/intake-formulieren/LocationView"),
			},
			{
				path: ":id/location/:locationId",
				component: () => import("../views/intake-formulieren/LocationForm"),
			},
			{
				path: ":id/location/:locationId/wijzigingsverzoek/:editrequestId",
				component: () => import("../views/intake-formulieren/EditRequest"),
			},
		],
	},
];

// The target of a #hash is usually rendered only after its page resolved its
// API call, so the element does not exist yet when the navigation settles.
// Poll a few frames for it and give up quietly — landing at the top of the page
// is the same result as having no hash at all.
function waitForHashTarget(hash, timeoutMs = 2000) {
	const deadline = Date.now() + timeoutMs;

	return new Promise((resolve) => {
		const look = () => {
			if (document.querySelector(hash) || Date.now() > deadline) {
				resolve(document.querySelector(hash) ? { el: hash, behavior: "smooth" } : false);
				return;
			}

			window.requestAnimationFrame(look);
		};

		look();
	});
}

const router = createRouter({
	history: createWebHistory(),
	routes,
	// Only hashes are handled here; without one this returns undefined, which is
	// the no-scroll behaviour this app had before.
	scrollBehavior(to) {
		if (to.hash) {
			return waitForHashTarget(to.hash);
		}
	},
});

// A page whose integration is off in the config sends you to the dashboard.
router.beforeEach((to) => (routeAvailable(to) ? true : "/"));

export default router;
